export enum FormTemplateType {
  REFRESH_RISK_PROFILE = 'quadrus-refresh-risk-profile',
  RISK_PROFILE = 'quadrus-risk-profile',
  RISK_PROFILE_MC_DOWELL = 'risk-profile-mcdowell',
}

export enum FormOptionKindType {
  EXTENDED = 'extended',
  SIMPLE = 'simple',
}

export enum FormQuestionContentDetailType {
  ADVISOR_DESCRIPTION = 'advisor_description',
  IMAGE = 'image',
  TEXT = 'text',
}

export enum QuestionType {
  BOOLEAN = 'boolean',
  MULTIPLE_CHOICE = 'multiple_choice',
  NUMBER = 'number',
  SINGLE_CHOICE = 'single_choice',
  TEXT = 'text',
}
